import { Container, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Collapse } from "reactstrap";
import { useRouter } from "next/router";
import useBranches from '@/hooks/useBranches';
import styles from "./styles.module.scss";
import Link from "next/link";
import React, { useState } from "react";

export const Branches = ({
  className,
  title,
  heading,
  titleColour,
  content
}) => {

  const { asPath } = useRouter();
  const locale = asPath === "/us" || asPath.startsWith("/us/") ? "/us/" : "/";

  const items = useBranches({locale});

  if (!items || !items.length > 0) {
    return null;
  }

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const [state, setState] = React.useState({});
  const { article } = state;

  React.useEffect(() => {
    setState((prevState) => ({
      moreInfoOpen: true,
    }));
    handleArticleOpen("0");
  }, []);

  const handleArticleOpen = (article) => {
    setState((prevState) => ({
      ...prevState,
      article,
    }));
  };

  const [selectedItem, setSelectedItem] = useState(
    "Select nearest office location"
  );

  return (
    <section className={`${styles.root} ${className}`}>
      <Container className="py-4 py-md-5">
        <div className="mb-4">
          {title &&
            <h2
              className={`text-${titleColour?.variant} ${heading}`}
              style={titleColour?.custom ? { color: titleColour?.custom } : null}
            >
              {title}
            </h2>
          }
          {content &&
            <div dangerouslySetInnerHTML={{ __html: content }} />
          }
        </div>
        {items ? (
          <div className='rounded-4 primary-bg p-4 locations-wrapper mb-5'>
            {/* Dropdown */}
            <Dropdown
              isOpen={dropdownOpen}
              toggle={toggle}
            >
              <DropdownToggle caret className='w-100 text-black'>
                {selectedItem || "Select nearest office location"}
              </DropdownToggle>
              <DropdownMenu>
                {items.map((item, index) => (
                  <DropdownItem
                    key={index}
                    onClick={() => {
                      handleArticleOpen(`${index}`);
                      setSelectedItem(item.title); // Update selected location
                    }}
                  >
                    {item?.title}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </Dropdown>

            {/* Details rendering */}
            {selectedItem !== "Select nearest office location" &&
              items.map((item, index) => (
                <Collapse isOpen={article === `${index}`} key={index}>
                  <div className='mt-4 text-black'>
                    <p className='m-0'>
                      <strong>Visit Us</strong>
                    </p>
                    {item?.address && (
                      <div
                        className='post-address'
                        dangerouslySetInnerHTML={{ __html: item?.address }}
                      />
                    )}
                    {item?.google_map_link && (
                      <div className='mb-4'>
                        <Link href={`${item?.google_map_link}`}>
                          <a
                            target='_blank'
                            rel='noopener noreferrer'
                            className='tertiaryBtn no-arrow'
                          >
                            Take me to Google Map
                          </a>
                        </Link>
                      </div>
                    )}
                    <p className='m-0'>
                      <strong>Send Us An Email</strong>
                    </p>
                    <p>
                      <Link href={`mailto:${item?.email}`}>
                        <a>{item.email}</a>
                      </Link>
                    </p>
                    <p className='m-0'>
                      <strong>Give Us A Ring</strong>
                    </p>
                    <p>
                      <Link href={`tel:${item?.telephone}`}>
                        <a>{item.telephone}</a>
                      </Link>
                    </p>
                  </div>
                </Collapse>
              ))}
          </div>
        ) : null}
      </Container>
    </section>
  );
};

export default Branches;
